// First-party analytics identity helpers.
//
// visitor_id : persistent, 2-year life (localStorage). Identifies a browser across
//              sessions. Fragments across browsers/incognito/cleared storage — the
//              server reports a stitched count alongside the raw one.
// session_id : a single visit. Rotates after 30 min of inactivity, and on tab close
//              where the browser fires pagehide. Stored with a last-activity stamp so
//              the rotation is deterministic and a tab left open for days no longer
//              counts as one endless session.

const VID_KEY = "os_vid";
const SSID_KEY = "os_ssid";
const CLOSED_KEY = "os_ssid_closed";
const TWO_YEARS_MS = 2 * 365 * 24 * 60 * 60 * 1000;
const IDLE_MS = 30 * 60 * 1000;

function rid(prefix) {
  return `${prefix}_${Math.random().toString(36).slice(2, 14)}`;
}

export function getVisitorId() {
  try {
    const raw = localStorage.getItem(VID_KEY);
    if (raw) {
      if (raw[0] === "{") {
        const o = JSON.parse(raw);
        if (o && o.id && o.exp && o.exp > Date.now()) return o.id;
      } else {
        // Migrate a legacy plain-string visitor id, preserving it (don't churn ids).
        localStorage.setItem(VID_KEY, JSON.stringify({ id: raw, exp: Date.now() + TWO_YEARS_MS }));
        return raw;
      }
    }
  } catch (e) {}
  const id = rid("vis");
  try { localStorage.setItem(VID_KEY, JSON.stringify({ id, exp: Date.now() + TWO_YEARS_MS })); } catch (e) {}
  return id;
}

// Read the current visitor id WITHOUT creating one (for the auth stitch call).
export function peekVisitorId() {
  try {
    const raw = localStorage.getItem(VID_KEY);
    if (!raw) return null;
    if (raw[0] === "{") { try { return JSON.parse(raw).id || null; } catch { return null; } }
    return raw;
  } catch { return null; }
}

export function getSessionId() {
  const now = Date.now();
  let rec = null;
  try { rec = JSON.parse(localStorage.getItem(SSID_KEY) || "null"); } catch (e) {}
  let closed = false;
  try { closed = localStorage.getItem(CLOSED_KEY) === "1"; } catch (e) {}
  const idle = !rec || !rec.id || (now - (rec.last || 0)) > IDLE_MS;
  const id = (idle || closed) ? rid("sess") : rec.id;
  try {
    localStorage.setItem(SSID_KEY, JSON.stringify({ id, last: now }));
    if (closed) localStorage.removeItem(CLOSED_KEY);
  } catch (e) {}
  return id;
}

// Mark the session as closed so the NEXT visit starts a fresh session (tab close /
// leaving the site). pagehide does not fire on SPA route changes, only real unloads.
export function markSessionClosed() {
  try { localStorage.setItem(CLOSED_KEY, "1"); } catch (e) {}
}

// UTM campaign parameters, captured ONCE from the landing URL for this JS load. A source /
// campaign is a property of the session (how it began), so the server reads the first event's
// values; we send the same captured set with every beacon of this page-load lifecycle.
let _utmCache;
export function getLandingUtm() {
  if (_utmCache !== undefined) return _utmCache;
  const out = {};
  try {
    const p = new URLSearchParams(window.location.search || "");
    ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].forEach((k) => {
      const v = (p.get(k) || "").trim();
      if (v) out[k] = v.slice(0, 120);
    });
  } catch (e) {}
  _utmCache = out;
  return out;
}
